import React, {useEffect, useState} from "react";
import {Modal} from "react-bootstrap";

export default function ShiftEnterPopupMessage(props) {
    const {
        title,
        message,
        okLabel,
        okButtonClassName,
        enabled,
        backdrop,
        keyboard,
        centered
    } = props;
    const [show, setShow] = useState(false);

    useEffect(() => {
        if (!enabled) {
            return undefined;
        }

        const handleShiftEnter = (e) => {
            const activeElement = document.activeElement;
            const isTextAreaFocused = activeElement && activeElement.type === 'textarea';

            if (e.shiftKey && e.key === 'Enter' && !isTextAreaFocused) {
                e.preventDefault();
                setShow(true);
            }
        }

        document.addEventListener('keydown', handleShiftEnter);

        return () => {
            document.removeEventListener('keydown', handleShiftEnter);
        }
    }, [enabled])

    return (
        <Modal
            show={show}
            onHide={() => setShow(false)}
            backdrop={backdrop}
            keyboard={keyboard}
            centered={centered}>
            <Modal.Header closeButton>
                <Modal.Title><b>{title}</b></Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {message}
            </Modal.Body>
            <Modal.Footer>
                <button className={okButtonClassName} onClick={() => setShow(false)}>{okLabel}</button>
            </Modal.Footer>
        </Modal>
    )
}

ShiftEnterPopupMessage.defaultProps = {
    title: 'Note',
    message: 'Shift + Enter can be used for a new line only when your cursor is in a text area.',
    okLabel: 'OK',
    okButtonClassName: 'btn td-btn-primary-light',
    enabled: true,
    backdrop: 'static',
    keyboard: false,
    centered: true
}
